import { HttpParams } from '@angular/common/http';
import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { FaqI } from 'src/app/interfaces/faq.interface';
import { FaqService } from 'src/app/services/faq/faq.service';

@Component({
  selector: 'app-render',
  templateUrl: './render.component.html',
  styleUrls: ['./render.component.css'],
})
export class RenderComponent {
  private observer!: IntersectionObserver;

  constructor(
    private elementRef: ElementRef,
    private readonly service: FaqService
  ) {}

  ngOnInit(): void {
    this.initIntersectionObserver();
  }

  ngOnDestroy(): void {
    // Asegúrate de desconectar el observer cuando el componente se destruya
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  private initIntersectionObserver(): void {
    const options = {
      root: null, // Observa en relación con el viewport actual
      threshold: 0.1, // Llama al callback cuando al menos el 10% del elemento esté visible
    };

    this.observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.loadData(); // Llamada a la función para cargar los datos
          this.observer.unobserve(entry.target); // Deja de observar después de que el componente se hace visible
        }
      });
    }, options);

    this.observer.observe(this.elementRef.nativeElement);
  }

  @Input() page!: number;
  @Input() header!: string;
  @Input() body!: string;
  @Output() data = new EventEmitter<FaqI[]>();
  private loadData(): void {
    // Aquí puedes hacer las consultas a la base de datos
    let params = new HttpParams();
    params = params.set('page', this.page);
    params = params.set('perPage', 12);
    params = params.set('activo', 1);
    if (this.body) params = params.set('body', this.body);
    if (this.header) params = params.set('header', this.header);

    this.service.getAllFilter(params).subscribe((data) => {
      this.data.emit(data.entities);
    });
    // Lógica para hacer la consulta o llamada HTTP a la base de datos
  }
}
